// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GivebackTimeline__container___f6_yc{padding:160px 32px}@media (max-width:719px){.GivebackTimeline__container___f6_yc{padding:80px 16px}}.GivebackTimeline__title___1P3Tc{max-width:703px;margin:0 auto;font-weight:200;font-size:48px;line-height:58px;text-align:center}@media (max-width:719px){.GivebackTimeline__title___1P3Tc{font-size:32px;line-height:42px}}.GivebackTimeline__description___3rR_F{max-width:950px;margin:8px auto 0;text-align:center}.GivebackTimeline__itemsContainer___Etz7O{display:flex;flex-wrap:wrap;grid-gap:50px;gap:50px;justify-content:space-evenly;margin-top:64px}.GivebackTimeline__item___2Zvwp{flex:1;min-width:220px;max-width:400px;text-align:center}.GivebackTimeline__itemLink___tTei5{display:inline-block;margin-top:24px}.GivebackTimeline__year___3Ss2W h2{color:inherit;font-weight:500;font-size:40px;line-height:56px}.GivebackTimeline__itemDescription___224wK p{color:#6b6651}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "GivebackTimeline__container___f6_yc",
	"title": "GivebackTimeline__title___1P3Tc",
	"description": "GivebackTimeline__description___3rR_F",
	"itemsContainer": "GivebackTimeline__itemsContainer___Etz7O",
	"item": "GivebackTimeline__item___2Zvwp",
	"itemLink": "GivebackTimeline__itemLink___tTei5",
	"year": "GivebackTimeline__year___3Ss2W",
	"itemDescription": "GivebackTimeline__itemDescription___224wK"
};
module.exports = ___CSS_LOADER_EXPORT___;
